import React, {useEffect} from 'react';
import {useSelector} from "react-redux";
import {CircularProgress} from "@mui/material";
import Box from "@mui/material/Box";
import Results from "./Results";
import {eventStatus} from "../../util/standards-util";
import Pilots from "./pilots";
import EventHome from "./EventHome";
import {useNavigate} from "react-router-dom";

const EventIndexPage = () => {
    const event = useSelector(state => state.session.event)

    const navigate = useNavigate()


    useEffect(() => {
        if (event) {
            if (event.status > eventStatus.STATUS_PLANNED_REGISTRATION_CLOSED) return (
                navigate('pilots')
            )
            else if (event.status === eventStatus.STATUS_COMPLETED) return (
                navigate('results')
            )
            else return (
                    navigate('home')
                )
        }
    }, []);

    useEffect(() => {
        if (event) {
            if (event.status > eventStatus.STATUS_PLANNED_REGISTRATION_CLOSED) return (
                navigate('pilots')
            )
            else if (event.status === eventStatus.STATUS_COMPLETED) return (
                navigate('results')
            )
            else return (
                    navigate('home')
                )
        }
    }, [event]);

    return (
            <Box sx={{p:'42vh'}}>
                <CircularProgress/>
            </Box>
    )

};

export default EventIndexPage;